import { createI18n } from 'vue-i18n'
import elementEnLocale from 'element-plus/lib/locale/lang/en'
import enLocale from './en'
import idLocale from './id'
import store from '../store'

const messages = {
  en: {
    ...enLocale,
    ...elementEnLocale
  },
  id: {
    ...idLocale,
    ...elementEnLocale
  }
}

const i18n = createI18n({
  locale: store.getters['app/lang'],
  messages
})

export default i18n
